import moment from 'moment'
import flightComponent from '../flightComponent/flightComponent.vue'
import carouselWeeks from '../carouselWeeks/carouselWeeks.vue'
import { mapFields } from 'vuex-map-fields'
import modalRT from '../calendar/modalRT.vue'
import modalOW from '../calendar/modalOW.vue'
import promoCode from '../promoCode/promoCode'
import { snakeCase, camelCase, get, orderBy } from 'lodash'
import axios from "axios";
import promiseBuilder from '../../promises/promiseBuilder'
import FareConditions from '../flightComponent/FareConditions'

export default {
  data () {
    return {
      fareSelected: null,
      defaultSortOptions: {
        lowerPrices: 1,
        higherPrices: 2,
        lessStops: 3,
        higherStops: 4,
        earliestFlights: 5,
        latestFlights: 6,
      },
      selectedFilter: 'earliestFlights',
      calendarError: false,
      minDate: moment()._d,
      maxDate: moment().add(330, 'days')._d,
      currentKey: 0,
      orderKey: 0,
      modalShowOW: false,
      modalShowRT: false,
      modalDataOW: {},
      modalDataRT: [],
      calendarEnabledDates: {}
    }
  },
  computed: {
    ...mapFields([
      'search',
      'departure_date',
      'return_date',
      'theFinalList',
      'theFinalReturnList'
    ]),
    totalCurrent () {
      return this.regions.reduce
    },
    totalPassengers () {
      return this.search.adults + this.search.minors + this.search.infants
    },
    totalDeployed () {
      return this.regions.reduce
    },
    totalVacant () {
      return this.regions.reduce
    },
    sortFieldSetting () {
      return get(
        this.$store.getters.getGeneralSettings, 'ecommerce_setup.sort_field_options', {}
      )
    },
    filteredSortFieldOptions () {
      const options = get(this.sortFieldSetting, 'options', this.defaultSortOptions)
      // TODO el backend deberia devolver una lista ordenada, no un array, y asi evitamos esta normalizacion!
      const normalizedOptions = Object.keys(options).map(key => ({ order: options[key], label: camelCase(key) }))
      return orderBy(normalizedOptions, ['order']).filter(option => option.order).map(x => x.label)
    },
    showSortField () {
      return get(this.sortFieldSetting, 'show_sort_field', true)
    },
    journeyOrigin () {
      return get(this.$store.getters.getSearchData, (this.selectingReturn ? 'destination' : 'origin'))
    },
    journeyLabel () {
      return `label_${this.selectingReturn ? 'return': 'departure'}`
    },
    journeyDestination () {
      return get(this.$store.getters.getSearchData, (this.selectingReturn ? 'origin' : 'destination'))
    },
    journeyPrettyTime () {
      return this.formatDate(
        this.flightsSource[this.journeysSource[this.journeys[0]].flights[0]]['departure_information'].date,
        'ddd DD MMM YYYY'
      )
    },
    journeyPrettyTimeFromStore () {
      return this.formatDate(this.$moment(get(this.$store.getters.getSearchData, (this.selectingReturn ? 'return_date' : 'departure_date')), 'DD/MM/YYYY'),
        'ddd DD MMM YYYY')
    }
  },
  props: [
    'journeys',
    'airports',
    'filters',
    'showTitle',
    'showOD',
    'showPassengers',
    'dismissSummary',
    'showTimeLine',
    'familyFares',
    'flightsSource',
    'journeysSource',
    'notListedFares',
    'value',
    'title',
    'currency',
    'showCarouselWeeks',
    'showSummary',
    'soldOutFareConfig',
    'weeks',
    'actualDate',
    'comparationDate',
    'dateToCompare',
    'headers',
    'selectingReturn',
    'showCarouselLowerFare',
    'showCarouselDepartureFlight',
    'showCarouselArrivalFlight',
    'showFamilyFareRules',
    'familyFareRules',
    'includeSearcher',
    'selectedSearchData',
    'promoCodeInformation',
    'lookingForReturn',
    'dateNoData',
    'showCalendar',
    'tripRoundtrip',
    'onlineInformation',
    'isReturn'
  ],
  components: {
    flightComponent,
    carouselWeeks,
    modalRT,
    modalOW,
    promoCode,
    FareConditions
  },
  watch: {
    departure_date (val) {
      if (this.flightsGoing[0]) {
        this.clearSelected()
        this.callFlightInfo()
      }
    },
    lang (val) {
      this.$forceUpdate()
    },
    journeys (val) {
      this.changeCurrentKey()
    }
  },
  beforeMount () {
    this.runOrderFlights()
    this.initCalendarEnabledDates()
  },
  methods: {
    runOrderFlights () {
      if (this.sortFieldSetting.show_sort_field) {
        this.selectedFilter = this.filteredSortFieldOptions[0]
      }
      this.orderFlights(this.selectedFilter)
    },
    getColumnTitle (column) {
      var r = null
      for (var v in this.headers) {
        if (this.headers[v].reference.replace(/ /g, '') === column.replace(/ /g, '')) r = this.$i18nParse(this.headers[v].title, this.$i18n.locale)
      }
      return !r ? column : r
    },
    nextWeek () {
      this.$emit('nextDate', undefined)
    },
    previousWeek () {
      this.$emit('prevDate', undefined)
    },
    getDateI18n (date) {
      let momentDate = moment(date.short_day, ['DD/MM/YYYY'])
      let day = momentDate.format('DD')
      let month = momentDate.format('MMM')
      month = month[0].toUpperCase() + month.substr(1)
      let year = momentDate.format('YYYY')
      return this.locale === 'es' ? `${day} ${month} ${year}` : `${month} ${day} ${year}`
    },
    getI18nDatePart (date, format) {
      let momentDate = moment(date.short_day, ['DD/MM/YYYY'])
      return momentDate.format(format)
    },
    getMonthI18n (date) {
      let momentDate = moment(date.short_day, ['DD/MM/YYYY'])
      return momentDate.format('MMM')
    },
    changeDate (valueGoing, valueReturn) {
      this.$emit('changeDate', valueGoing, valueReturn)
    },
    validDate (date) {
      date = moment(date.short_day, ['DD/MM/YYYY'])
      return this.comparationDate(this.dateToCompare, date)
    },
    formatDate (date, format) {
      return moment(date).locale(this.$i18n.locale).format(format ? format : 'DD/MM/YY')
    },
    toggleSummary () {
      this.$emit('toggleSummary', undefined)
    },
    cleanFareName (fareName) {
      return fareName.split('_')[0]
    },
    onSelected ({ price, flight, fare, journeyName, finalList, generalInfo }) {
      this.fareSelected = { title: fare.name + '_' + journeyName, name: this.cleanFareName(fare.name) }

      let summaryConflictiveData = new Promise((resolve, reject) => {
        if (this.selectingReturn) {
          this.theFinalReturnList = finalList
        } else {
          this.theFinalList = finalList
        }
        resolve()
      })
      const source = this.flightsSource
      const selectedData = this.selectedSearchData
      summaryConflictiveData.then((successMessage) => {
        this.$emit('input', { price, flight, fare, journeyName, generalInfo })
        this.$emit('selectFlight', { price, flight, fare, journeyName, generalInfo, source, selectedData })
      })
    },
    defaultFlightSort () {
      this.journeys.sort((a, b) => {
        const source = this.journeysSource

        if (source[a].order.lower_price > source[b].order.lower_price) {
          return 1
        } else if (source[a].order.lower_price < source[b].order.lower_price) {
          return -1
        }

        if (moment(this.flightsSource[source[a].flights[0]].departure_information.time, 'HH:mm:ss').isBefore(moment(this.flightsSource[source[b].flights[0]].departure_information.time, 'HH:mm:ss'))) {
          return 1
        } else if (moment(this.flightsSource[source[b].flights[0]].departure_information.time, 'HH:mm:ss').isBefore(moment(this.flightsSource[source[a].flights[0]].departure_information.time, 'HH:mm:ss'))) {
          return -1
        }

        if (source[a].order.stop_conn_factor > source[b].order.stop_conn_factor) {
          return 1
        } else if (source[a].order.stop_conn_factor < source[b].order.stop_conn_factor) {
          return -1
        }
      })
      this.orderKey++
    },
    orderFlights (by) {
      let asc = null
      let orderByTime = false
      this.defaultFlightSort()

      if (by === 'lowerPrices') {
        by = 'lower_price'
        asc = true
      }
      if (by === 'higherPrices') {
        by = 'lower_price'
        asc = false
      }
      if (by === 'lessStops') {
        by = 'stop_conn_factor'
        asc = true
      }
      if (by === 'higherStops') {
        by = 'stop_conn_factor'
        asc = false
      }
      if (by === 'earliestFlights') {
        orderByTime = true
        asc = true
      }
      if (by === 'latestFlights') {
        orderByTime = true
        asc = false
      }

      if (orderByTime) {
        this.journeys.sort((a, b) => {
          const firstFlightTime = moment(this.flightsSource[this.journeysSource[a].flights[0]].departure_information.time, 'HH:mm:ss')
          const secondFlightTime = moment(this.flightsSource[this.journeysSource[b].flights[0]].departure_information.time, 'HH:mm:ss')

          if (moment(firstFlightTime).isBefore(secondFlightTime)) {
            return asc ? -1 : 1
          } else {
            return asc ? 1 : -1
          }
        })
        return
      }

      this.journeys.sort((a, b) => {
        const source = this.journeysSource
        return asc ? source[a].order[by] - source[b].order[by] : source[b].order[by] - source[a].order[by]
      })

      this.orderKey++
    },
    changeCurrentKey () {
      this.currentKey = this.currentKey + 1
    },
    initCalendarEnabledDates () {
      if (
        (this.selectingReturn && this.showCarouselArrivalFlight) ||
        (!this.selectingReturn && this.showCarouselDepartureFlight) || this.showCalendar) {

        const url = this.$store.getters.getConfigUrls.apiBaseUrl + 'searchflight/api/v1'

        axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
        let promise = axios({
          method: 'get',
          url: `${url}/dates/`,
          params: {
            origin: this.search.origin,
            destination: this.search.destination,
            is_round_trip: this.search.return_flight ? 1 : 0
          }
        })

        if (process.env.VUE_APP_FAKE_RESPONSE_DATES) {
          promise = promiseBuilder(process.env.VUE_APP_FAKE_RESPONSE_DATES)
        }

        promise.then((resp) => {
          this.calendarEnabledDates = resp.data.response
        })
        .catch((err) => {
          console.error('error api get dates', err)
        })
      }
    },
    openmodal () {
      let promise = null
      var result_array = []
      var total_array = []
      // para probar en local. se habilita en el .env.local
      this.$store.commit('setLoading', true)

      if (process.env.VUE_APP_FAKE_RESPONSE_PCALENDAR) {
        promise = promiseBuilder(process.env.VUE_APP_FAKE_RESPONSE_PCALENDAR)
      } else {
        const url = `${this.$store.getters.getConfigUrls.apiUrl}get_price_calendar/`
        promise = axios.get(url)
      }
      promise.then((response) => {
        console.log('resp get_price_calendar', response)
        if (this.tripRoundtrip) {
          for (var x = 0; x < 49; x=x+7) {
            for (var i = 0; i < 7; i++) {
              result_array.push(response.data.response[i+x])
            }
            total_array.push(result_array)
            result_array = []
          }
          this.modalDataRT = total_array
          this.modalShowRT = true
        } else {
          this.modalDataOW = response.data.response
          // this.modalShowOW = true
        }
        })
        .catch((err) => {
          this.$store.commit('setLoading', false)
          console.log('error api get_price_calendar', err)
        })
        .finally(() => {
          this.$store.commit('setLoading', false)
        })
    },
    getTokenOfGeneralSettings (token) {
      return get(this.$store.getters.getGeneralSettings, `ecommerce_setup.${token}`)
    },
    snakeCase
  }
}
